import { Col, Row, Select, Checkbox, Space, Switch } from "antd";
import React from "react";
import "../styles.css";

const spanstyles = {
  marginRight: 8,
};

export const getDocumentDefaultConfigs = {
  document_view: false,
  document_check_in: false,
  document_print: false,
  document_delete: false,
  document_upload: false,
  document_re_index: false,
  document_download: false,
  document_full_text_search: false,
  document_version_history: false,
  document_version_val: undefined,
  document_version_rollback: false,
  document_share: false,
  // document_domains:[],
  document_is_custom_inputs_allowed_reindex: false,
};

function DocumentSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      {/* //begin - hide not implemented elements
            <Row>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_view')} checked={props.config.document_view}/></span>
                    <span style={spanstyles}>View</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_check_in')} checked={props.config.document_check_in} /></span>
                    <span style={spanstyles}>Check In</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_print')} checked={props.config.document_print} /></span>
                    <span style={spanstyles}>Print</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_delete')} checked={props.config.document_delete} /></span>
                    <span style={spanstyles}>Delete</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_upload')} checked={props.config.document_upload} /></span>
                    <span style={spanstyles}>Upload</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_re_index')} checked={props.config.document_re_index} /></span>
                    <span style={spanstyles}>Re-Index</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_download')} checked={props.config.document_download} /></span>
                    <span style={spanstyles}>Download</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_full_text_search')} checked={props.config.document_full_text_search} /></span>
                    <span style={spanstyles}>Full Text Search</span>
                </Col>
            </Row>
            <Row>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_version_history')} checked={props.config.document_version_history}/></span>
                    <span style={spanstyles}>Version History</span>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <div style={spanstyles}><Select value={props.config.document_version_val} style={{width:"100%"}} placeholder="Please Select" onChange={e=>props.updateValue(e,props._id,'document_version_val')} showSearch={true}
                    filterOption={(input, option) =>{
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }}
                    >
                        <Select.Option value={"Show All"}>Show All</Select.Option>
                    </Select></div>
                </Col>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_version_rollback')} checked={props.config.document_version_rollback}/></span>
                    <span style={spanstyles}>Version Rollback</span>
                </Col>
            </Row>
            <Row>
                <Col xxl={2} xl={3} lg={4} sm={6}>
                    <span style={spanstyles}><Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_share')} checked={props.config.document_share}/></span>
                    <span style={spanstyles}>Share</span>
                </Col> //end - hide not implemented elements
                */}
      {/* <Col xxl={4} xl={6} lg={8} sm={12}>
                    <div style={spanstyles}><Select value={props.config.document_domains} style={{width:"100%"}} showSearch={true} 
                    filterOption={(input, option) =>{
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }} 
                mode="multiple" placeholder="Please Select" onChange={e=>props.updateValue(e,props._id,'document_domains')}>
                        <Select.Option value="marriott.com">marriott.com</Select.Option>
                        <Select.Option value="mydigitaloffice.ca">mydigitaloffice.ca</Select.Option>
                        <Select.Option value="holidayinn.com">holidayinn.com</Select.Option>
                        <Select.Option value="marriotthotels.com">marriotthotels.com</Select.Option>
                        <Select.Option value="hotelsholdings.com">hotelsholdings.com</Select.Option>
                        <Select.Option value="marriottsuites.com">marriottsuites.com</Select.Option>
                        <Select.Option value="deerpark.com">deerpark.com</Select.Option>
                    </Select></div>
                </Col> */}
      {/*
            //hide not implemented elements
            </Row>*/}
      <Row>
        <Col xxl={2} xl={4} lg={6} sm={6}>
          <Space>
            <span>Adhoc Reindexing</span>
            <Switch
              onChange={(e) => {
                props.updateValue(
                  e,
                  props._id,
                  "document_is_custom_inputs_allowed_reindex"
                );
              }}
              size="small"
              checked={props.config.document_is_custom_inputs_allowed_reindex}
            />
          </Space>
          {/* <span style={spanstyles}>
                        <span style={spanstyles}>Ad Hoc Enable</span>
                        <Checkbox onChange={e=>props.updateValue(e.target.checked,props._id,'document_is_custom_inputs_allowed_reindex')} checked={props.config.document_is_custom_inputs_allowed_reindex}/>
                    </span> */}
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(DocumentSettings);
